import * as _ from 'lodash';
import { FormEvent, Fragment, MouseEvent, useState } from 'react';
import { IContactEntityTypePositions } from '@nkr/models/index';
import { Button, ControlLabel, FormControl, FormGroup, Glyphicon, Label } from 'react-bootstrap';
import { useAppHookContext } from '@nkr/utils/rest-api';
import { OrganType } from '@nkr/enums/organ-type';

interface IProps {
    entityType: number,
    selectedRoles: number[],
    otherText: string,
    positionList: IContactEntityTypePositions[],
    valid: boolean,
    onAdd: (list: number[]) => void,
    onRemove: (list: number[]) => void,
    onOtherTextChange: (e: FormEvent<FormControl & HTMLInputElement>) => void
}

const Roles = (props: IProps) => {
    const { app: { site } } = useAppHookContext();

    const [selectedAvailable, setSelectedAvailable] = useState([]);
    const [selectedCurrent, setSelectedCurrent] = useState([]);

    const selectAvailable = (currentTarget: EventTarget & FormControl & HTMLSelectElement) => {
        let { options } = currentTarget;
        options = Array.apply(null, options)
        let selectedAvailable = (options as any).filter(x => x.selected).map(x => x.value);

        setSelectedAvailable(selectedAvailable);
    }

    const selectCurrent = (currentTarget: EventTarget & FormControl & HTMLSelectElement) => {
        let { options } = currentTarget;
        options = Array.apply(null, options)
        let selectedCurrent = (options as any).filter(x => x.selected).map(x => x.value);

        setSelectedCurrent(selectedCurrent);
    }

    const add = () => {
        let list = selectedAvailable.map(x => parseInt(x));

        setSelectedAvailable([]);

        props.onAdd(list);
    }

    const remove = () => {
        let list = selectedCurrent.map(x => parseInt(x));

        setSelectedCurrent([]);

        props.onRemove(list);
    }

    const handleAvailableClick = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        selectAvailable(e.currentTarget);
    };

    const handleAvailableDoubleClick = (e: MouseEvent<FormControl & HTMLSelectElement>) => {
        selectAvailable(e.currentTarget);
        add();
    }

    const handleSelectedClick = (e: FormEvent<FormControl & HTMLSelectElement>) => {
        selectCurrent(e.currentTarget);
    };

    const handleSelectedDoubleClick = (e: MouseEvent<FormControl & HTMLSelectElement>) => {
        selectCurrent(e.currentTarget);
        remove();
    };

    const handleAdd = () => {
        add();
    };

    const handleRemove = () => {
        remove();
    };

    let groupList = props.positionList.filter(x => x.entityTypeId == props.entityType);

    if (site.organType == OrganType.Liver) {
        groupList = groupList.filter(x => x.organType != OrganType.Kidney);
    }

    const roleList = props.positionList.filter(x => x.entityTypeId == props.entityType).flatMap(x => x.positions);

    const sortedSelectedRoles = _.sortBy(roleList.filter(x => props.selectedRoles.indexOf(x.id) >= 0), item => item.description);

    return (
        <div style={{ border: '1px solid #ccc', borderRadius: 4, padding: '10px 15px 15px 15px' }}>
            <div style={{ display: 'flex' }}>
                <div style={{ width: '42.5%' }}>
                    <div style={{ paddingLeft: 5 }}>Available Roles</div>

                    <FormControl
                        componentClass='select'
                        multiple
                        size={7}
                        bsSize='sm'
                        value={selectedAvailable}
                        onChange={handleAvailableClick}
                        onDoubleClick={handleAvailableDoubleClick}
                    >
                        {groupList.length > 1 && groupList.map((group, index) =>
                            <Fragment key={'role-group-' + index}>
                                <optgroup><legend style={{ marginBottom: 5, fontSize: 12, fontWeight: 550, borderBottom: '0 none', marginTop: index == 0 ? 0 : 5 }}>{group.entityType}</legend></optgroup>
                                {_.sortBy(group.positions, x => x.description).map((position, positionIndex) => {
                                    let f = props.selectedRoles.find(roleId => roleId == position.id);

                                    if (!f) {
                                        return (
                                            <option key={'role-group-item-' + positionIndex} value={position.id}>{position.description}</option>
                                        );
                                    }
                                })}
                            </Fragment>
                        )}

                        {groupList.length == 1 && groupList.map((group, index) =>
                            <Fragment key={'role-group-' + index}>
                                {_.sortBy(group.positions, x => x.description).map((position, positionIndex) =>
                                    <option key={'role-group-item-' + positionIndex} value={position.id}>{position.description}</option>
                                )}
                            </Fragment>
                        )}
                    </FormControl>
                </div>

                <div style={{ width: '15%', padding: '35px 5px 0px 5px' }}>
                    <Button bsSize='xs' block onClick={handleAdd}>+ <Glyphicon glyph='chevron-right' /></Button>
                    <Button bsSize='xs' block onClick={handleRemove}><Glyphicon glyph='chevron-left' /> -</Button>
                </div>

                <div style={{ width: '42.5%' }}>
                    <div style={{ paddingLeft: 5 }}>Selected Roles</div>

                    <FormControl
                        componentClass='select'
                        multiple
                        size={7}
                        bsSize='sm'
                        value={selectedCurrent}
                        onChange={handleSelectedClick}
                        onDoubleClick={handleSelectedDoubleClick}
                    >
                        {sortedSelectedRoles.map(role =>
                            <option value={role.id}>{role.description}</option>
                        )}
                    </FormControl>
                </div>
            </div>

            {sortedSelectedRoles.find(x => x.id == 0) != null && (
                <div style={{ paddingTop: 5 }}>
                    <FormGroup style={{ marginBottom: 0 }}>
                        <ControlLabel>Role <Label>if other</Label></ControlLabel>
                        <FormControl
                            id='positionText'
                            value={props.otherText}
                            onChange={props.onOtherTextChange}
                        />
                    </FormGroup>
                </div>
            )}
        </div>
    );
}

export default Roles;